import React, { useCallback, useEffect, useMemo, useState } from 'react';
import { Menu, message, Popconfirm} from 'antd';
import {
  UsergroupAddOutlined,
  AppstoreAddOutlined,
  LogoutOutlined,
  BarcodeOutlined,
  AppstoreOutlined,
  BankOutlined,
  IdcardOutlined
} from '@ant-design/icons';
import { Link } from 'react-router-dom';

import { AppRoutes } from 'configs/AppRoutes';

import { useAuth } from 'features/auth/hooks';

import { allow_manager_roles } from 'helpers/authorizeHelper';

function getItem(label, key, icon, children) {
  return {
    key,
    icon,
    children,
    label
  };
}

export default function Navigation() {
  const [selectedKeys, setSelectedKeys] = useState([]);
  const [openKeys, setOpenKeys] = useState([]);

  const items = useMemo(() => {
    const items = [];
    if (allow_manager_roles(['super_admin'])) {
      items.push(
        getItem('Statistics', 'sub', <AppstoreOutlined />, [
          getItem(
            <Link to={AppRoutes.Statistics.Accounts.path}>
              {AppRoutes.Statistics.Accounts.label}
            </Link>,
            AppRoutes.Statistics.Accounts.path,
          ),
          getItem(
            <Link to={AppRoutes.Statistics.OrderPayments.path}>
              {AppRoutes.Statistics.OrderPayments.label}
            </Link>,
            AppRoutes.Statistics.OrderPayments.path,
          ),
          getItem(
            <Link to={AppRoutes.Statistics.Messages.path}>
              {AppRoutes.Statistics.Messages.label}
            </Link>,
            AppRoutes.Statistics.Messages.path,
          ),
          getItem(
            <Link to={AppRoutes.Statistics.TenantDetails.path}>
              {AppRoutes.Statistics.TenantDetails.label}
            </Link>,
            AppRoutes.Statistics.TenantDetails.path,
          )
        ])
      );  
    }   

    if (allow_manager_roles(['super_admin', 'sale', 'support'])) {
      items.push(
        getItem('Accounts', 'sub2', <AppstoreOutlined />, [
          getItem(
            <Link to={AppRoutes.Accounts.ListAiHub.path}>
              {AppRoutes.Accounts.ListAiHub.label}
            </Link>,
            AppRoutes.Accounts.ListAiHub.path,
            <AppstoreAddOutlined />
          ),
          getItem(
            <Link to={AppRoutes.Accounts.ListAiStore.path}>
              {AppRoutes.Accounts.ListAiStore.label}
            </Link>,
            AppRoutes.Accounts.ListAiStore.path,
            <AppstoreAddOutlined />
          ),
          getItem(
            <Link to={AppRoutes.Accounts.ListAiReseller.path}>
              {AppRoutes.Accounts.ListAiReseller.label}
            </Link>,
            AppRoutes.Accounts.ListAiReseller.path,
            <AppstoreAddOutlined />
          )
        ])
      );
    }

    if (allow_manager_roles(['super_admin'])) {
      items.push(
        getItem(
          <Link to={AppRoutes.Apps.List.path}>
            {AppRoutes.Apps.List.label}
          </Link>,
          AppRoutes.Apps.List.path,
          <AppstoreAddOutlined />
        )
      );
    }

    if (allow_manager_roles(['super_admin', 'sale', 'support'])) {
      items.push(
        getItem(
          <Link to={AppRoutes.OrderPayments.List.path}>
            {AppRoutes.OrderPayments.List.label}
          </Link>,
          AppRoutes.OrderPayments.List.path,
          <BarcodeOutlined />
        )
      );
    }

    if (allow_manager_roles(['super_admin'])) {
      items.push(
        getItem(
          <Link to={AppRoutes.OrderPayments.ListPartner.path}>
            {AppRoutes.OrderPayments.ListPartner.label}
          </Link>,
          AppRoutes.OrderPayments.ListPartner.path,
          <BarcodeOutlined />
        )
      );
    }

    if (allow_manager_roles(['super_admin'])) {
      items.push(
        getItem(
          <Link to={AppRoutes.RecommendApps.List.path}>
            {AppRoutes.RecommendApps.List.label}
          </Link>,
          AppRoutes.RecommendApps.List.path,
          <AppstoreOutlined />
        )
      );
    }

    if (allow_manager_roles(['super_admin'])) {
      items.push(
        getItem(
          <Link to={AppRoutes.Subscriptions.List.path}>
            {AppRoutes.Subscriptions.List.label}
          </Link>,
          AppRoutes.Subscriptions.List.path,
          <BankOutlined />
        )
      );
    }

    if (allow_manager_roles(['super_admin', 'sale', 'support'])) {   
      items.push(
        getItem(
          <Link to={AppRoutes.Tenants.List.path}>
            {AppRoutes.Tenants.List.label}
          </Link>,
          AppRoutes.Tenants.List.path,
          <IdcardOutlined />
        )
      );
    }

    if (allow_manager_roles(['super_admin'])) {
      items.push(
        getItem(
          <Link to={AppRoutes.CustomDomains.List.path}>
            {AppRoutes.CustomDomains.List.label}
          </Link>,
          AppRoutes.CustomDomains.List.path,
          <IdcardOutlined />
        )
      );
    }
    
    if (allow_manager_roles(['super_admin', 'sale', 'support'])) {
      items.push(
        getItem(
          <Link to={AppRoutes.Credits.List.path}>
            {AppRoutes.Credits.List.label}
          </Link>,
          AppRoutes.Credits.List.path,
          <IdcardOutlined />
        )
      );
    }

    if (allow_manager_roles(['super_admin', 'sale', 'support'])) {
      items.push(
        getItem(
          <Link to={AppRoutes.MonthlyCredits.List.path}>
            {AppRoutes.MonthlyCredits.List.label}
          </Link>,
          AppRoutes.MonthlyCredits.List.path,
          <IdcardOutlined />
        )
      );
    }

    if (allow_manager_roles(['super_admin'])) {
      items.push(
        getItem(
          <Link to={AppRoutes.PromoCodes.List.path}>
            {AppRoutes.PromoCodes.List.label}
          </Link>,
          AppRoutes.PromoCodes.List.path,
          <IdcardOutlined />
        )
      );
    }

    if (allow_manager_roles(['super_admin'])) {
      items.push(
        getItem('Affiliates', 'sub3', <AppstoreOutlined />, [
          getItem(
            <Link to={AppRoutes.Affiliates.CommissionList.path}>
              {AppRoutes.Affiliates.CommissionList.label}
            </Link>,
            AppRoutes.Affiliates.CommissionList.path,
            <IdcardOutlined />
          ),
          getItem(
            <Link to={AppRoutes.Affiliates.WithdrawList.path}>
              {AppRoutes.Affiliates.WithdrawList.label}
            </Link>,
            AppRoutes.Affiliates.WithdrawList.path,
            <IdcardOutlined />
          )
        ])
      );
    }

    if (allow_manager_roles(['super_admin'])) {
      items.push(
        getItem('Affiliates Store', 'sub4', <AppstoreOutlined />, [
          getItem(
            <Link to={AppRoutes.Affiliates.CommissionStoreList.path}>
              {AppRoutes.Affiliates.CommissionStoreList.label}
            </Link>,
            AppRoutes.Affiliates.CommissionStoreList.path,
            <IdcardOutlined />
          ),
          getItem(
            <Link to={AppRoutes.Affiliates.WithdrawStoreList.path}>
              {AppRoutes.Affiliates.WithdrawStoreList.label}
            </Link>,
            AppRoutes.Affiliates.WithdrawStoreList.path,
            <IdcardOutlined />
          )
        ])
      );
    }

    if (allow_manager_roles(['super_admin'])) {
      items.push(
        getItem(
          <Link to={AppRoutes.Managers.List.path}>
            {AppRoutes.Managers.List.label}
          </Link>,
          AppRoutes.Managers.List.path,
          <IdcardOutlined />
        )
      );
    }

    return items;
  }, []);

  useEffect(() => {
    const hashPath = window.location.href;
    if (hashPath.indexOf(AppRoutes.Accounts.ListAiHub.path) !== -1) {
      setSelectedKeys([AppRoutes.Accounts.ListAiHub.path]);
      setOpenKeys([]);
    }
  }, []);

  const onSelectMenuItem = useCallback((item, key) => {
    setSelectedKeys([item.key]);
  }, []);

  const onOpenChange = useCallback((keys) => {
    setOpenKeys(keys);
  }, []);

  const { logout } = useAuth();

  const handleLogout = () => {
    logout();
    message.success('Đã đăng xuất thành công.');
  };

  items.push(
    getItem(
      <Popconfirm
        placement="topRight"
        title={`Bạn có chắc muốn đăng xuất?`}
        onConfirm={handleLogout}
        okText="Yes"
        cancelText="No"
      >
        <a href="/">Đăng xuất</a>
      </Popconfirm>,
      null,
      <LogoutOutlined />
    )
  );

  return (
    <Menu
      theme="dark"
      mode="inline"
      items={items}
      selectedKeys={selectedKeys}
      onSelect={onSelectMenuItem}
      openKeys={openKeys}
      onOpenChange={onOpenChange}
    ></Menu>
  );
}
